module.exports = __webpack_public_path__ + "static/media/il.5a12c248.svg";